import { log } from "./log"

export const extractValueOrTransform = (item, keyOrFn) => {
  const res = typeof keyOrFn === 'function' ? keyOrFn(item) : item[keyOrFn]
//  log('ᛈᛖ‍ᛡᚩ‍ᚱᚦ extractValueOrTransform', item, keyOrFn, res)
  return res
}

export function isDexieTableExists(dx, name) {
  return dx.tables.map((d) => d.name).includes(name)
}

export function getSingleData(dx, tableName, uuid) {
  return dx.table(tableName).where({ externalId: uuid }).toArray()
}
